import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import Hero from '../../sections/Hero';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const DeliveryServicePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Delivery Services</title>
        <meta
          name="description"
          content="Professional delivery services in Northeast Wisconsin. Fast, reliable, and affordable delivery solutions for all your needs."
        />
      </Helmet>

      <Hero 
        title="Professional Delivery Services"
        subtitle="Fast, reliable and affordable delivery solutions for Northeast Wisconsin."
        backgroundImage="/assets/images/delivery-service-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom>
            Our Delivery Services
          </Typography>
          <Typography variant="body1" paragraph>
            JBR Delivery LLC offers comprehensive delivery services in Northeast Wisconsin. With our experienced team and well-maintained fleet, we ensure your items arrive safely and on time.
          </Typography>
          <Typography variant="body1" paragraph>
            Whether you need furniture delivery, appliance delivery, or any other type of item transported, our team is equipped to handle it with care and professionalism.
          </Typography>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default DeliveryServicePage;
